import { Typography, Box } from '@mui/material'
import React from 'react'

const SectionQuestion = (props: {
  question: string
  id: string
  description: string
}) => {
  const { question, id, description } = props
  // description might not be required - need to confirm it with product team tomorrow
  return (
    <Box key={id}>
      <Typography variant="h6">{question}</Typography>
      <Typography variant="body1"> {description} </Typography>
    </Box>
  )
}

export default SectionQuestion
